import React from 'react'
import { useQuery } from '@apollo/client'
import classNames from 'classnames'
import gql from 'graphql-tag'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { fetchPolicy } from 'lib/apolloFetchPolicy'

import './app-loading-bar.pcss'

const AppLoadingBar = () => {
    const { data } = useQuery(gql`
        query bosSaving {
            bosSaving @client
        }
    `, { variables: {}, fetchPolicy: fetchPolicy.CACHE_ONLY })

    return (
        <div
            className={classNames(
                'app-loading-bar',
                { 'app-loading-bar--loading': data.bosSaving },
            )}
        />
    )
}

export default withErrorBoundaryNoRender(AppLoadingBar)
